import * as Types from '../../../../types/schema.generated';

import gql from 'graphql-tag';
import { ChatPageHeaderMemoFragmentDoc } from '../ChatPageHeader.generated';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type DiagnosisByUserDetailFragment = { __typename?: 'DiagnosisByUser', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, cards: { __typename?: 'Cards', annualIncome: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } } };

export type ChatRoomQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type ChatRoomQuery = { __typename?: 'Query', ownChatRoom?: { __typename?: 'ChatRoom', id: string, status: Types.ChatRoomStatus, memos: Array<{ __typename?: 'ChatRoomMemo', id: string, content: string, createdAt: TimeString }>, user?: { __typename?: 'User', lineActivationUser?: { __typename?: 'LineActivationUser', isBlocked: boolean } | null } | null } | null, viewer: { __typename?: 'Viewer', is400FOA: boolean, hasLineActivationProvider: boolean, staff: { __typename?: 'Staff', role: Types.StaffRole } } };

export type DiagnosisByUserQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type DiagnosisByUserQuery = { __typename?: 'Query', diagnosisByUser: { __typename?: 'DiagnosisByUser', personality: { __typename?: 'Personality', type: Types.PersonalityType, title: string, description: string }, cards: { __typename?: 'Cards', annualIncome: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, savingAnnual: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyRentCost: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, investment: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean }, monthlyInsurance: { __typename?: 'CardMetric', name: string, title: string, rank?: Types.RankInCluster | null, myValue: number, averageValue: number, unit: string, message: string, showBarGraph: boolean } } } };

export const DiagnosisByUserDetailFragmentDoc = gql`
    fragment diagnosisByUserDetail on DiagnosisByUser {
  personality {
    type
    title
    description
  }
  cards {
    annualIncome {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    savingAnnual {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyRentCost {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    investment {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
    monthlyInsurance {
      name
      title
      rank
      myValue
      averageValue
      unit
      message
      showBarGraph
    }
  }
}
    `;
export const ChatRoomDocument = gql`
    query chatRoom($id: ID!) {
  ownChatRoom(id: $id) {
    id
    status
    memos {
      ...ChatPageHeaderMemo
    }
    user {
      lineActivationUser {
        isBlocked
      }
    }
  }
  viewer {
    is400FOA
    staff {
      role
    }
    hasLineActivationProvider
  }
}
    ${ChatPageHeaderMemoFragmentDoc}`;

/**
 * __useChatRoomQuery__
 *
 * To run a query within a Vue component, call `useChatRoomQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatRoomQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useChatRoomQuery({
 *   id: // value for 'id'
 * });
 */
export function useChatRoomQuery(variables: ChatRoomQueryVariables | VueCompositionApi.Ref<ChatRoomQueryVariables> | ReactiveFunction<ChatRoomQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, variables, options);
}
export function useChatRoomLazyQuery(variables?: ChatRoomQueryVariables | VueCompositionApi.Ref<ChatRoomQueryVariables> | ReactiveFunction<ChatRoomQueryVariables>, options: VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<ChatRoomQuery, ChatRoomQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<ChatRoomQuery, ChatRoomQueryVariables>(ChatRoomDocument, variables, options);
}
export type ChatRoomQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<ChatRoomQuery, ChatRoomQueryVariables>;
export const DiagnosisByUserDocument = gql`
    query diagnosisByUser($userId: ID!) {
  diagnosisByUser(userId: $userId) {
    ...diagnosisByUserDetail
  }
}
    ${DiagnosisByUserDetailFragmentDoc}`;

/**
 * __useDiagnosisByUserQuery__
 *
 * To run a query within a Vue component, call `useDiagnosisByUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useDiagnosisByUserQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useDiagnosisByUserQuery({
 *   userId: // value for 'userId'
 * });
 */
export function useDiagnosisByUserQuery(variables: DiagnosisByUserQueryVariables | VueCompositionApi.Ref<DiagnosisByUserQueryVariables> | ReactiveFunction<DiagnosisByUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>(DiagnosisByUserDocument, variables, options);
}
export function useDiagnosisByUserLazyQuery(variables?: DiagnosisByUserQueryVariables | VueCompositionApi.Ref<DiagnosisByUserQueryVariables> | ReactiveFunction<DiagnosisByUserQueryVariables>, options: VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>(DiagnosisByUserDocument, variables, options);
}
export type DiagnosisByUserQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<DiagnosisByUserQuery, DiagnosisByUserQueryVariables>;